import React from "react";
import {Close} from "assets/icons";
import {getLicenceSubtitle} from "helper/licences";
import {formatCalendarDate} from "helper/residencePermit";
import LicenceIconTile from "components/licences/LicenceIconTile";
import useLicenceTexts from "components/licences/useLicenceTexts";

const LicenceRow = ({entry, onOpen, onDelete}) => {
    const {translate, getLabel} = useLicenceTexts();
    const label = getLabel(entry);
    const subtitle = getLicenceSubtitle(entry, (key) => translate(`list.state.${key}`), formatCalendarDate);

    return (
        <div className="flex items-center gap-4 py-3">
            <button
                type="button"
                onClick={() => onOpen(entry)}
                className="flex items-center gap-4 grow min-w-0 text-left"
            >
                <LicenceIconTile entry={entry}/>
                <div className="flex flex-col min-w-0">
                    <span className="ft-b font-semibold text-gray-900">{label}</span>
                    <span className="ft-sm text-gray-500">{subtitle}</span>
                </div>
            </button>
            {/* Only entries the api marks deletable (pending, refused) keep their cross. */}
            {entry.deletable === true && (
                <button
                    type="button"
                    onClick={() => onDelete(entry)}
                    aria-label={`${translate("list.delete")} ${label}`}
                    className="shrink-0 p-2 rounded-full hover:bg-gray-100"
                >
                    <Close wh={20} color={"#374151"}/>
                </button>
            )}
        </div>
    );
};

export default LicenceRow;
